module.exports = __webpack_public_path__ + "img/6.7cf7bd04.png";